export const FETCH_USER_LOGIN_REQUEST = "FETCH_USER_LOGIN_REQUEST";
export const FETCH_USER_LOGIN_SUCCESS = "FETCH_USER_LOGIN_SUCCESS";
export const FETCH_USER_LOGIN_FAILURE = "FETCH_USER_LOGIN_FAILURE";
export const FETCH_USER_LOGOUT = "FETCH_USER_LOGOUT";
